import Api from '@/services/Api'

export default {
  list (params) {
    return Api().post('prematch/list', params)
  },
  matches (params) {
    return Api().post('prematch/matches', params)
  },
  popular (params) {
    return Api().post('prematch/popular', params)
  },
  event (event) {
    return Api().get('prematch/event/' + event)
  }
}



// WEBPACK FOOTER //
// ./src/services/PrematchService.js